

































import { Component, Mixins, Prop } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import { DomainRegistry } from "../../domain";
import { DocumentManageKinds } from "../../domain/system";
import { DispatchDocumentResult } from "../../domain/workflow/document";
import { GuestWizardDocumentEditViewMixin } from "../document/mixins";
import { UnmanagedLoginView } from "../authentication";
import { ExistingDocumentEditor } from "./editors/wizard/guest";

@Component({
  components: {
    UnmanagedLoginView,
    ExistingDocumentEditor,
  }
})
export default class GuestWizardDocumentEditView extends Mixins(GuestWizardDocumentEditViewMixin) {
  @Prop()
  documentId: number;

  @Prop()
  orderNo: string;

  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  shouldSelectDepartment: boolean;

  $refs!: {
    authenticator: UnmanagedLoginView,
  };

  data() {
    return {
      isRegistered: false,
    };
  }
  isRegistered: boolean;

  async beforeEnter(to: Route): Promise<RawLocation> {
    const result = await this.getDocumentManageType(Number(to.query.documentId), to.query.patientNo.toString());
    switch (result.manageType) {
      case DocumentManageKinds.Reception:
        // 暫定対応。将来的にはWF用にdispatchする。
        return {
          path: "/Error",
          query: {
            url: to.fullPath,
            message: "ワークフロー文書のため編集できません。",
          }
        };
      default:
        if (!result.isEditable) {
          return {
            path: "/Wizard/Guest/ShowDocument",
            replace: true,
            query: {
              patientNo: to.query.patientNo,
              documentId: to.query.documentId,
              userCode: to.query.userCode,
              departmentCode: to.query.departmentCode,
            },
          };
        }
        return;
    }
  }

  authenticate(isForcibly: boolean): Promise<boolean> {
    return this.$refs.authenticator.authenticate(isForcibly);
  }

  async doAuthenticate(userId: string, password: string): Promise<void> {
    await DomainRegistry.instance.document.getAuthenticationService().authenticateWizard(userId, password);
  }

  async onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number): Promise<void> {
    this.isEditing = false;
    this.isRegistered = true;
    this.notifyDocumentListMessage("documentRegistered");
    this.notifyRegisteredMessage();
  }

  private async getDocumentManageType(documentId: number, patientNo: string): Promise<DispatchDocumentResult> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.dispatchDocument(documentId, patientNo, null);
      return result;
    } catch (e) {
      console.error("文書管理タイプの取得に失敗しました。", "直接記載モードで起動しています。", e);
      const dummyResult = new DispatchDocumentResult();
      dummyResult.manageType = DocumentManageKinds.Normal;
      return dummyResult;
    }
  }
}
